import { render, staticRenderFns } from "./proposal-detail-to-print.vue?vue&type=template&id=067de8e3&scoped=true&"
import script from "./proposal-detail-to-print.vue?vue&type=script&lang=ts&"
export * from "./proposal-detail-to-print.vue?vue&type=script&lang=ts&"
import style0 from "./proposal-detail-to-print.vue?vue&type=style&index=0&id=067de8e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067de8e3",
  null
  
)

export default component.exports